export default __webpack_public_path__ + "static/media/MaisonNeue-BookItalic.69b3f9d8.woff2";